import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import { Text } from 'foundations-components/components/Text';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import useOnboardingIntroModal from '../../hooks/useOnboardingIntroModal';
import { REP_OVERVIEW } from '../../constants/Events';
import { trackCancelUITour } from '../../utils/usageTracker';
import { getIsDealStageView } from '../../selectors/forecastSelectors';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OnboardingIntroModal = () => {
  const {
    isOpen,
    toggleModal,
    startTour
  } = useOnboardingIntroModal();
  const isDealStageView = useSelector(getIsDealStageView);
  const handleClick = useCallback(() => {
    toggleModal(false);
    trackCancelUITour('onboarding-intro-modal', REP_OVERVIEW, isDealStageView);
  }, [isDealStageView, toggleModal]);
  if (!isOpen) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: 740,
    "data-test-id": "onboarding-forecast-modal",
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "tour.onboarding.intro.header"
        })
      })
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      width: 580,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "tour.onboarding.intro.body"
      })
    }), /*#__PURE__*/_jsx(UIDialogHeaderImage, {
      offsetBottom: 59,
      offsetTop: -25,
      children: /*#__PURE__*/_jsx(Illustration, {
        name: "forecasting",
        width: 180
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      align: "left",
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: startTour,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "tour.onboarding.intro.buttons.primary"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "onboarding-forecast-modal-skip-tour",
        onClick: handleClick,
        use: "transparent",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "tour.onboarding.intro.buttons.secondary"
        })
      })]
    })]
  });
};
export default OnboardingIntroModal;